function m(g, e, C, i, t) {
  var a, D, n, h;
  if (!i || !t.startingCellData || (t.startingCellData.minSelection || 0) <= 1)
    return !1;
  const l = t == null ? void 0 : t.disabledByMinSelectionBoundsCells.at(-1);
  if (!l)
    return !1;
  const f = (D = (a = t == null ? void 0 : t.integratedDataStore) == null ? void 0 : a.get) == null ? void 0 : D.call(a, l);
  return !((n = f == null ? void 0 : f.cellData) != null && n.month) || ((h = f == null ? void 0 : f.cellData) == null ? void 0 : h.month) === t.startingCellData.month || !g || g.month < t.startingCellData.month || e.isNextMonth && C < t.startingCellData.month || g.month > f.cellData.month || e.isPreviousMonth && C > f.cellData.month ? !1 : (e.isPreviousMonth && g.month < f.cellData.month || e.isNextMonth && C < f.cellData.month, !0);
}
function d(g, e, C, i, t, l) {
  var f, a;
  return !t || !((f = l.consideredCells) != null && f.length) && !((a = l.selectedCells) != null && a.length) && !l.endingCellData || !g || !l.startingCellData || !l.endOfRangeActiveCellData ? !1 : C && l.endingCellData ? e > l.startingCellData.month && e <= l.endingCellData.month : C ? e > l.startingCellData.month && e <= l.endOfRangeActiveCellData.month : i && l.endingCellData ? e >= l.startingCellData.month && e < l.endingCellData.month : i ? e >= l.startingCellData.month && e < l.endOfRangeActiveCellData.month : !1;
}
export {
  d as getIsHighlightedOverflowCell,
  m as getIsMinSelectionOverflowCell
};
